<template>
<div>
    <div class="bar" id="barId"></div>
    <div class="background">
        <!-- 我的流量 -->
        <div class="myData">
            <img src="../../assets/dataPack/rsManage/我的流量.png" alt="" class="dataIcon1">
            <div class="dataText1">我的流量</div>
            <div class="dataLine1"></div>
            <div class="dataLine2"></div>
            <img src="../../assets/dataPack/rsManage/流量监控.png" alt="" class="dataIcon2 dataIcon2b" @click="openTrafficSetting">
            <div class="dataText2 dataText2b" @click="openTrafficSetting">流量使用设置</div>
            <img src="../../assets/dataPack/rsManage/流量监控.png" alt="" class="dataIcon2" @click="openTrafficMonitor">
            <div class="dataText2" @click="openTrafficMonitor">流量监控</div>
        </div>
        <div class="basisData">基础流量
            <div class="basisText1" @click="$router.push('/GeneralTraffic/purchaseData')">购买流量</div>
        </div>
        <div class="basisCtn">
            <div v-for="(item, index) in basisList" :key="'basisList'+index" class="basisListCtn">
                <div class="basisInner">
                    <img src="../../assets/dataPack/rsManage/每日免费流量.png" alt="" class="basisIcon1" v-if="item.flowType=='free'">
                    <img src="../../assets/dataPack/rsManage/基础流量包.png" alt="" class="basisIcon1" v-if="item.flowType=='basic'">
                    <div class="basisText2">{{ item.packageName }}</div>
                    <div class="basisText3" v-if="flowStatusSubtitle(item)">{{ flowStatusSubtitle(item) }}</div>
                    <div class="basisText4">已用{{ item.usedCount }}次</div>
                    <div class="basisText5">剩余{{item.remainingCount}}次/共{{ item.flowSum }}次</div>
                    <a-progress
                        :percent="getUsagePercent(item)"
                        :show-info="false"
                        class="basisLine1"
                        :strokeWidth="4"
                        strokeColor="#00A855"
                        v-if="item.flowType=='free'"
                    />
                    <a-progress
                        :percent="getUsagePercent(item)"
                        :show-info="false"
                        class="basisLine1"
                        :strokeWidth="4"
                        strokeColor="#1890FF"
                        v-if="item.flowType=='basic'"
                    />
                    <div class="basisText7">到期时间：{{ item.expireTime }}</div>
                </div>
            </div>
            <!-- 基础流量为空时的空状态 -->
            <span v-if="basisList.length === 0" class="basis-empty">
                <img src="../../assets/dataPack/rsManage/我的流量.png" alt="" class="basis-empty-icon">
                <div class="basis-empty-text">
                    暂无可用的基础流量，<span class="basis-empty-link" @click="showFreePackageDialog=true">点击领取每日免费流量</span>
                </div>
            </span>
        </div>
        <div class="basisData" style="margin-top: 28px;">高级流量
            <div class="basisText1" @click="$router.push({ path: '/GeneralTraffic/purchaseData', query: { tier: 'premium' } })">购买流量</div>
        </div>
        <div class="basisCtn" style="min-height: 200px;">
            <div v-for="(item, index) in highList" :key="'highList'+index" class="basisListCtn">
                <div class="basisInner">
                    <img src="../../assets/dataPack/rsManage/高级流量包.png" alt="" class="basisIcon1" v-if="item.flowType=='premium'">
                    <div class="basisText2">{{ item.packageName }}</div>
                    <div class="basisText3" v-if="flowStatusSubtitle(item)">{{ flowStatusSubtitle(item) }}</div>
                    <div class="basisText4">已用{{ item.usedCount }}次</div>
                    <div class="basisText5">剩余{{item.remainingCount}}次/共{{ item.flowSum }}次</div>
                    <a-progress
                        :percent="getUsagePercent(item)"
                        :show-info="false"
                        class="basisLine1"
                        :strokeWidth="4"
                        strokeColor="#722ED1"
                    />
                    <div class="basisText7">到期时间：{{ item.expireTime }}</div>
                </div>
            </div>
            <span v-if="highList.length === 0">
                <img src="../../assets/dataPack/rsManage/钻石.png" alt="" style="position: absolute;top: 23px;left: 498px;width: 100px;">
                <div class="premuimText1">暂无可用的高级流量</div>
            </span>
        </div>
        <!-- 图源包年流量 -->
        <template v-if="annualList.length > 0">
            <div class="basisData" style="margin-top: 28px;">图源包年流量
                <div class="basisText1 annualPurchaseLink" @click="$router.push('/AnnualPurchase/annualPurchaseData')">购买图源包年服务</div>
            </div>
            <div class="basisCtn">
                <div v-for="(item, index) in annualList" :key="'annualList'+index" class="basisListCtn annualListCtn">
                    <div class="basisInner">
                        <img src="../../assets/dataPack/rsManage/包年图源.png" alt="" class="basisIcon1">
                        <div class="basisText2 annualText2">{{ item.mkName }}</div>
                        <div class="basisText4">{{ annualUsedText(item) }}</div>
                        <div class="basisText5">剩余{{ Math.ceil(Number(item.remainingCount)) }}次/每日{{ Math.ceil(Number(item.flowSum)) }}次</div>
                        <a-progress
                            :percent="getUsagePercent(item)"
                            :show-info="false"
                            class="basisLine1"
                            :strokeWidth="4"
                            :strokeColor="Number(item.status) === 2 || Number(item.status) === 3 ? '#BFBFBF' : '#2F54EB'"
                        />
                        <div class="basisText7 annualRegion">服务区域：{{ item.regionName }}</div>
                        <div class="basisText7 annualExpireTime">到期时间：{{ item.expireTime }}</div>
                    </div>
                </div>
            </div>
        </template>
        <!-- 图源列表 -->
        <div id="source-list-section" class="myData" style="margin-top: 28px;">
            <img src="../../assets/dataPack/rsManage/图源列表.png" alt="" class="dataIcon1">
            <div class="dataText1">图源列表</div>
            <div class="dataLine1"></div>
            <div class="dataLine2" style="right: 40px;width: 500px;"></div>
        </div>
        <div class="listTab">
            <div :class="tab == 1 ? 'basisTab' : 'basisTab-s'" @click="switchDataTab(1)">
                <img src="../../assets/dataPack/rsManage/基础图源-白色.png" alt="" v-if="tab==1" style="position: absolute;top: 16px;left: 40px;">
                <img src="../../assets/dataPack/rsManage/基础图源-灰色.png" alt="" v-if="tab==2" style="position: absolute;top: 16px;left: 40px;">
                <div :class="tab == 1 ? 'basisText6' : 'basisText6-s'">基础图源</div>
                <div class="basisLine2" v-if="tab==1"></div>
            </div>
                <div :class="tab == 2 ? 'highTab-s' : 'highTab'" @click="switchDataTab(2)">
                    <img src="../../assets/dataPack/rsManage/高级图源-白色.png" alt="" v-if="tab==2" style="position: absolute;top: 16px;left: 40px;">
                    <img src="../../assets/dataPack/rsManage/高级图源-灰色.png" alt="" v-if="tab==1" style="position: absolute;top: 16px;left: 40px;">
                    <div :class="tab == 2 ? 'basisText6' : 'basisText6-s'">高级图源</div>
                    <div class="basisLine2" v-if="tab==2"></div>
                </div>
                <!-- 仅查看已购包年图源 -->
                <div class="annualFilter">
                    <a-checkbox v-model="annualFilterChecked" class="annualFilterBox" />
                    <div class="annualFilterText">仅查看已购包年图源</div>
                </div>
            </div>
        <div style="margin-top: 36px;"></div>
        <!-- 仅查看已购包年图源 + 无已购数据：空状态 -->
        <div class="annualEmpty" v-if="annualFilterChecked && dataList.length === 0">
            <img src="../../assets/dataPack/rsManage/未购买包年图源.png" alt="" class="annualEmptyImg">
            <div class="annualEmptyText">当前分类下暂无已购包年图源</div>
            <div class="annualEmptyLink" @click="$router.push('/AnnualPurchase/annualPurchaseData')">购买图源包年服务</div>
        </div>
        <!-- 基础/高级 path id  -->
        <div class="listCtn" v-for="(item, index) in dataList" :key="'dataList'+index">
            <div class="level1" @click="toggleExpand(item)">
                <span class="levelText1">{{ item.name }}</span>
                <span class="levelIcon1" v-if="item.list && item.list.length">{{ item.expanded ? '▼' : '▶' }}</span>
            </div>
            <div v-if="item.expanded && item.list">
                <div style="margin-top: 24px;"></div>
                <div v-for="(subItem, subIndex) in item.list" :key="subIndex">
                    <div class="level2" @click="toggleExpand(subItem)">
                        <div class="levelText2">{{ subItem.name }}</div>
                        <div class="levelLabelExperience" v-if="subItem.name === '2025年全国高质量一张图'||subItem.name === '2022年全球一张图'">体验图源</div>
                        <div class="levelLabel1">{{ subItem.type }}</div>
                        <div class="levelLabel1" style="width: 80px;margin-right: 16px;">{{ subItem.imageGsd }}</div>
                        <span class="levelIcon2" v-if="(subItem.photoList && subItem.photoList.length) || (subItem.list && subItem.list.length)">
                            <img src="../../assets/dataPack/rsManage/下箭头.png" alt="" style="width: 100%;" v-if="subItem.expanded">
                            <img src="../../assets/dataPack/rsManage/右箭头.png" alt="" style="height: 100%;" v-if="!subItem.expanded">
                        </span>
                        <div class="levelLabel3" @click.stop="goImageSegmentationWithMk(subItem.id)">影像拆分</div>
                        <div class="levelLabel3" style="right: 200px;" @click="showCopyPanel(subItem.iv,subItem.name,subItem.tk,subItem.pro)">复制链接</div>
                        <div class="levelLabel4" @click="jumpWithPermission('仅登录','/lab','/rskit',subItem)">立即浏览</div>
                    </div>
                    <div v-if="subItem.expanded && subItem.photoList" class="level3Ctn">
                        <div v-for="(photo, photoIndex) in subItem.photoList"  :key="photoIndex">
                            <div class="level3" @click="toggleExpand(photo)">
                                <div class="levelText3">{{ photo.name }}</div>
                                <div class="levelLabelExperience" style="margin-top: 8px;margin-right:16px;" v-if="subItem.name === '2024年度全国高质量一张图'||subItem.name === '2022年全球一张图'">体验图源</div>
                                <div :class="['levelLabel2', { levelLabel2Premium: tab === 2 }]" v-if="photo.year">包年图源</div>
                                <div class="levelLabel1" style="margin-top: 8px;margin-right: 16px;">{{ photo.type }}</div>
                                <div class="levelLabel1" style="margin-right: 16px;;width: 80px;margin-top: 8px;">{{ photo.imageGsd || subItem.imageGsd }}</div>
                                <span class="levelIcon2" v-if="photo.list && photo.list.length" style="top: 9px;right: 34px;">
                                    <img src="../../assets/dataPack/rsManage/下箭头.png" alt="" style="width: 100%;" v-if="photo.expanded">
                                    <img src="../../assets/dataPack/rsManage/右箭头.png" alt="" style="height: 100%;" v-if="!photo.expanded">
                                </span>
                                <div style="float: right;margin-right: 78px;width: 2px;height: 1px;"></div>
                                <div class="levelLabel5" v-if="photo.year" @click.stop="goImageSegmentationWithMk(photo.id, { name: photo.name, iv: photo.iv, tk:photo.tk, pro:photo.pro,isAnnual:photo.isAnnual,annualId:photo.annualId })">影像拆分</div>
                                <div class="levelLabel5" @click="showCopyPanel(photo.iv,photo.name,photo.tk,photo.pro)">复制链接</div>
                                <div class="levelLabel5" @click="jumpWithPermission('仅登录','/lab','/rskit',photo)">立即浏览</div>
                            </div>
                            <div v-if="photo.expanded && photo.list">
                                    <div v-for="(child, childIndex) in photo.list" :key="childIndex" class="level4">
                                        <div class="levelText3">{{ child.name }}</div>
                                        <div class="levelLabelExperience" style="margin-top: 8px;margin-right: 16px;" v-if="subItem.name === '2024年度全国高质量一张图'||subItem.name === '2022年全球一张图'">体验图源</div>
                                        <div :class="['levelLabel2', { levelLabel2Premium: tab === 2 }]" >包年图源</div>
                                        <div class="levelLabel1" style="margin-top: 8px;margin-right: 16px;">{{ child.type }}</div>
                                        <div class="levelLabel1" style="margin-right: 16px;width: 80px;margin-top: 8px;">
                                            {{ child.imageGsd || photo.imageGsd || subItem.imageGsd }}
                                        </div>
                                        <div style="float: right;margin-right: 54px;width: 2px;height: 1px;"></div>
                                        <div class="levelLabel5" @click="showCopyPanel(child.iv,child.name,child.tk,child.pro)">复制链接</div>
                                        <div class="levelLabel5" @click="jumpWithPermission('仅登录','/lab','/rskit',child)">立即浏览</div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 工具文档 -->
        <div class="myData" style="margin-top: 48px;">
            <img src="../../assets/dataPack/rsManage/工具文档.png" alt="" class="dataIcon1">
            <div class="dataText1">工具文档</div>
            <div class="dataLine1"></div>
            <div class="dataLine2" style="right: 40px;width: 500px;"></div>
        </div>
        <div class="wordCtn">
            <div class="wordBlock">
                <img src="../../assets/dataPack/rsManage/矢量库管理.png" alt="" class="wordIcon">
                <div class="wordText1">矢量库管理</div>
                <div class="wordText2">支持绘制多类型矢量、选择行政区域、上传矢量文件</div>
                <div class="wordBtn1" @click="$router.push('/vectoryLibrary')">使用</div>
            </div>
            <div class="wordBlock">
                <img src="../../assets/dataPack/rsManage/矢量库管理.png" alt="" class="wordIcon">
                <div class="wordText1">影像拆分管理</div>
                <div class="wordText2">利用自定义矢量进行影像拆分，聚焦感兴趣区域</div>
                <div class="wordBtn1" @click="goImageSegmentationAll()">使用</div>
            </div>
            <div class="wordBlock">
                <img src="../../assets/dataPack/rsManage/PDF.png" alt="" class="wordIcon">
                <div class="wordText1" style="top: 28px;">吉林一号在线地图访问使用说明书</div>
                <div class="wordBtn1" @click="openFile(4)">查看</div>
            </div>
            <div class="wordBlock">
                <img src="../../assets/dataPack/rsManage/PDF.png" alt="" class="wordIcon">
                <div class="wordText1" style="top: 28px;">在线地图访问常见问题帮助文档</div>
                <div class="wordBtn1" @click="openFile(1)">查看</div>
            </div>
            <div class="wordBlock">
                <img src="../../assets/dataPack/rsManage/PDF.png" alt="" class="wordIcon">
                <div class="wordText1" style="top: 28px;">Web端工具集SDK使用说明书（V1.0）</div>
                <div class="wordBtn1" @click="openFile(2)">查看</div>
            </div>
            <div class="wordBlock">
                <img src="../../assets/dataPack/rsManage/PDF.png" alt="" class="wordIcon">
                <div class="wordText1" style="top: 28px;">移动端工具集SDK使用说明书（V1.0）</div>
                <div class="wordBtn1" @click="openFile(3)">查看</div>
            </div>
        </div>
    </div>
    <TrafficCalendar v-if="showTrafficMonitor" @close-calendar="showTrafficMonitor=false"></TrafficCalendar>

    <div class="shadow" v-if="showCopyPanelVisiable" id="keyIconId" data-clipboard-action="copy" :data-clipboard-text="copyUrl">
        <div class="shadowContent1" style="height:810px;top: calc(50% - 405px);">
            <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose1" @click="showCopyPanelVisiable=false">
            <div class="shadowtext1" style="width:100%;left:unset;">{{copyPanelMkName}}</div>
            <div class="tips" style="top: 108px;">使用场景1：基于 Openlayers / QGIS / Leaflet 等</div>
            <div class="address" style="top:150px">
                <div class="mark"><span class="allKey">https://api.jl1mall.com/getTile/{z}/{x}/{-y}?mk=<span class="key">{{copyPanelMk}}</span>&tk=<span class="key">{{copyPanelTk!=''?copyPanelTk:copyPanelCommonTk}}</span>{{copyPanelPro!=''?'&pro=':''}}<span v-if="copyPanelPro!=''" class="key">{{copyPanelPro}}</span></span></div>
                <div class="copyBtn" @click="copyAddress(1)">复制地址</div>
            </div>
            <div class="tips" style="top:260px;">使用场景2：基于 Cesium</div>
            <div class="address" style="top:303px">
                <div class="mark"><span class="allKey">https://api.jl1mall.com/getTile/{z}/{x}/{reverseY}?mk=<span class="key">{{copyPanelMk}}</span>&tk=<span class="key">{{copyPanelTk!=''?copyPanelTk:copyPanelCommonTk}}</span>{{copyPanelPro!=''?'&pro=':''}}<span v-if="copyPanelPro!=''" class="key">{{copyPanelPro}}</span></span></div>
                <div class="copyBtn" @click="copyAddress(2)">复制地址</div>
            </div>
            <div class="tips" style="top:410px;">使用场景3：基于 Mapbox</div>
            <div class="address" style="top:450px">
                <div class="mark"><span class="allKey">https://api.jl1mall.com/getTile/{z}/{x}/{y}?mk=<span class="key">{{copyPanelMk}}</span>&tk=<span class="key">{{copyPanelTk!=''?copyPanelTk:copyPanelCommonTk}}</span>{{copyPanelPro!=''?'&pro=':''}}<span v-if="copyPanelPro!=''" class="key">{{copyPanelPro}}</span></span></div>
                <div class="copyBtn" @click="copyAddress(3)">复制地址</div>
            </div>
            <div class="tips" style="top:560px;">使用场景4：基于 ArcMap / ArcGIS Pro</div>
            <div class="address" style="top:600px">
              <div class="mark"><span class="allKey">https://api.jl1mall.com/getCapabilities?mk=<span class="key">{{copyPanelMk}}</span>&tk=<span class="key">{{copyPanelTk!=''?copyPanelTk:copyPanelCommonTk}}</span>{{copyPanelPro!=''?'&pro=':''}}<span v-if="copyPanelPro!=''" class="key">{{copyPanelPro}}</span>&flow=true</span></div>
              <div class="copyBtn" @click="copyAddress(4)">复制地址</div>
            </div>
            <a class="readMore" @click="openFile(4)">详细了解Key的用法 ></a>

        </div>
    </div>

     <!-- 认证身份弹窗 -->
     <div class="shadow" v-if="shadowTip">
        <div class="shadowWhite">
            <img src="../../assets/calendar/日历关闭.png" alt="" class="shadowClose" @click="shadowTip=false">
            <div class="shadowText1">用户身份认证</div>
            <div class="shadowText2">根据国家地理信息安全与保密相关规定，为规范数据使用，保障您的合法权益，购买和使用卫星遥感数据需完成<span style="font-weight: 600;">机构企业用户</span>/<span style="font-weight: 600;">教育科研用户</span>认证。（认证后可享受会员价格）</div>
            <div class="shadowSel" @click="authentication('/store/ApplyGovernmentMember')">
                <img src="../../assets/dataPack/rsManage/企业用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
            </div>
            <div class="shadowSel" @click="authentication('/store/OpenEducationalCertification')" style="left: 400px;">
                <img src="../../assets/dataPack/rsManage/教育用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
            </div>
        </div>
    </div>
    <!-- 机构企业：授权委托书（顶栏提示叠在蒙层上方） -->
    <div v-if="authLetterModalVisible" class="authLetterLayer">
        <div class="authLetterShadow" @click.self="closeAuthLetterModal">
            <div class="authLetterModal" @click.stop>
                <img src="../../assets/calendar/日历关闭.png" alt="" class="authLetterClose" @click="closeAuthLetterModal">
                <div class="authLetterTitle">{{ authLetterTitle }}</div>
                <div class="authLetterDesc" v-if="authLetterModalMode!=='rejected'">{{ authLetterBodyText }}</div>
                <template v-else>
                    <div class="authLetterDesc">很抱歉，您的授权委托书未通过审核，请重新上传。</div>
                    <div class="authLetterReject" v-if="authorizationLetterRejectReason">未通过原因：{{ authorizationLetterRejectReason }}</div>
                </template>
                <div
                    class="authLetterDrop"
                    :class="{ 'authLetterDrop--active': authLetterDragOver }"
                    @click="triggerAuthFileInput"
                    @dragover.prevent="onAuthDragOver"
                    @dragleave.prevent="onAuthDragLeave"
                    @drop.prevent="onAuthFileDrop"
                >
                    <input
                        ref="authFileInput"
                        type="file"
                        class="authLetterFileInput"
                        accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                        @change="onAuthFileChange"
                    >
                    <div class="authLetterDropIcon" aria-hidden="true">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" fill="#1E81EB" fill-opacity="0.15"/>
                            <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" stroke="#1E81EB" stroke-width="1.2"/>
                            <path d="M12 9v6M9 12h6" stroke="#1E81EB" stroke-width="1.2" stroke-linecap="round"/>
                        </svg>
                    </div>
                    <div class="authLetterDropLine1">点击或将文件拖拽到这里上传</div>
                    <div class="authLetterDropLine2">支持扩展名：.pdf .jpg .png .jpeg</div>
                </div>
                <div class="authLetterFileRow" v-if="authLetterPendingName">
                    <span class="authLetterFileClip">&#128206;</span>
                    <span class="authLetterFileName">{{ authLetterPendingName }}</span>
                    <span class="authLetterFileRemove" @click.stop="clearAuthFile">×</span>
                </div>
                <div class="authLetterBar" v-if="authLetterPendingName"></div>
                <a
                    href="javascript:;"
                    class="authLetterLink"
                    :class="{ 'authLetterLink--disabled': authLetterTemplateLoading }"
                    @click.prevent="downloadAuthLetterTemplate"
                >{{ authLetterTemplateLoading ? '正在获取…' : '点击下载授权委托书模版' }}</a>
                <div class="authLetterBtns">
                    <div class="authLetterBtn1" :class="{ 'authLetterBtn1--disabled': authLetterUploading }" @click="confirmAuthLetterAction">{{ authLetterPrimaryLabel }}</div>
                    <div class="authLetterBtn2" v-if="!authLetterUploading" @click="closeAuthLetterModal">暂不上传</div>
                </div>
            </div>
        </div>
        <div v-if="authLetterTopTip" class="authLetterTopTip">
            <div
                class="authLetterTopTipInner"
                :class="'authLetterTopTipInner--' + authLetterTopTipType"
            >
                <span class="authLetterTopTipMark" v-if="authLetterTopTipType === 'success'">✓</span>
                <span class="authLetterTopTipMark" v-else>×</span>
                <span class="authLetterTopTipText">{{ authLetterTopTip }}</span>
            </div>
        </div>
    </div>
    <!-- 领取每日免费流量弹窗 -->
    <div class="shadow" v-if="showFreePackageDialog">
        <div class="free-dialog">
            <img src="~@/assets/newHome/关闭.png" alt="" class="free-dialog-close" @click="showFreePackageDialog=false"/>
            <div class="free-dialog-title">领取每日免费流量</div>
            <div class="free-dialog-desc">每日免费流量可用于"基础图源-免费体验图源"</div>
            <div class="free-dialog-check">
                <input type="checkbox" v-model="agreedTerms" class="free-checkbox"/>
                <span class="free-check-text">我已阅读并同意</span>
                <span class="free-link" @click="openPDF()">《吉林一号在线访问产品使用协议》</span>
            </div>
            <div class="free-dialog-buttons">
                <div class="free-btn-cancel" @click="showFreePackageDialog=false">暂不领取</div>
                <div class="free-btn-confirm" :class="{'free-btn-disabled': !agreedTerms}" @click="handleClaim">立即领取</div>
            </div>
        </div>
    </div>
    <!-- 领取成功弹窗 -->
    <div class="shadow" v-if="showSuccessDialog">
        <div class="success-dialog">
            <img src="~@/assets/newHome/关闭.png" alt="" class="free-dialog-close" @click="showSuccessDialog=false"/>
            <div class="success-icon">
                <span class="success-check">✓</span>
            </div>
            <div class="success-title">领取成功！</div>
            <div class="success-desc">
                每日免费流量每日发放<span class="success-highlight">4W次</span>，次日重置<br/>
                可前往"在线地图访问-图源管理"查看每日免费流量的使用情况以及使用<span class="success-link-text">【基础图源-免费体验图源】</span>
            </div>
            <div class="success-buttons">
                <div class="success-btn-cancel" @click="showSuccessDialog=false">暂不前往</div>
                <div class="success-btn-confirm" @click="scrollToSourceList">立即前往</div>
            </div>
        </div>
    </div>
    <!-- 流量使用设置弹窗 -->
    <div class="shadow" v-if="showFlowSettingDialog">
        <div class="flowSettingDialog">
            <span class="flowSettingClose" @click="closeFlowSetting"></span>
            <div class="flowSettingTitle">流量使用设置</div>
            <div class="flowSettingDivider"></div>
            <!-- 模式选择 -->
            <div class="flowModeCard" :class="{'flowModeCard--active': flowProtectionMode === 'continuous'}" @click="flowProtectionMode='continuous'">
                <div class="flowModeRadio" :class="{'flowModeRadio--on': flowProtectionMode === 'continuous'}"></div>
                <div class="flowModeContent">
                    <div class="flowModeHeader">
                        <div class="flowModeName">连续消耗模式</div>
                        <div class="flowModeDefault">默认</div>
                    </div>
                    <div class="flowModeDesc">按照各类型源的流量消耗顺序依次扣减，当前流量用尽后自动消耗下一类流量。</div>
                </div>
            </div>
            <div class="flowModeCard" :class="{'flowModeCard--active': flowProtectionMode === 'protect'}" @click="flowProtectionMode='protect'">
                <div class="flowModeRadio" :class="{'flowModeRadio--on': flowProtectionMode === 'protect'}"></div>
                <div class="flowModeContent">
                    <div class="flowModeHeader">
                        <div class="flowModeName">流量保护模式</div>
                    </div>
                    <div class="flowModeDesc">每个图源仅消耗顺序中的第一类流量，用尽后不再消耗其他类型流量。</div>
                </div>
            </div>
            <!-- 优先级信息卡 -->
            <div class="flowPriorityCard">
                <img src="../../assets/dataPack/rsManage/优先级提示.png" alt="" class="flowPriorityIcon">
                <div class="flowPriorityTitle">各类图源的流量消耗优先级</div>
                <div class="flowPriorityRow">
                    <div class="flowPriorityType">已购买包年服务</div>
                    <div class="flowPriorityArrow">图源包年流量 → 按图源类型继续扣减</div>
                </div>
                <div class="flowPriorityRow">
                    <div class="flowPriorityType">基础图源-体验图源</div>
                    <div class="flowPriorityArrow">每日免费流量 → 基础流量 → 高级流量</div>
                </div>
                <div class="flowPriorityRow">
                    <div class="flowPriorityType">基础图源-非体验图源</div>
                    <div class="flowPriorityArrow">基础流量 → 高级流量</div>
                </div>
                <div class="flowPriorityRow">
                    <div class="flowPriorityType">高级图源</div>
                    <div class="flowPriorityArrow">高级流量</div>
                </div>
                <div class="flowPriorityDivider"></div>
                <div class="flowPriorityTip">选择"流量保护模式"时，第一类流量用尽后停止图源访问，不再消耗其他类型流量。</div>
            </div>
            <!-- 底部按钮 -->
            <div class="flowSettingBottomDivider"></div>
            <div class="flowSettingBtns">
                <div class="flowSettingCancel" @click="closeFlowSetting">取消</div>
                <div class="flowSettingSave" @click="saveFlowSetting">保存设置</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// 0免费体验图源系列、1全国高质量一张图系列、2全国季度一张图系列、3全球一张图（基础版）系列、4全球一张图（高级版）系列（跟实验室一致，需同步维护）
const folderMapping = {
  '0':'免费体验图源系列',
  '1':'全国年度一张图系列',
  '2':'全国双月一张图系列',
  '3':'全国季度一张图系列',
  '4':'全国半年精选图系列',
  '5':'全球一张图（基础版）系列',
  '6':'全球一张图（高级版）系列'
}
import {rootUrl} from '@/globalConfig'
import TrafficCalendar from '@/components/trafficMonitor/calendar.vue'
import Clipboard from 'clipboard';

export default {
name: "rsManage",
components: {
    TrafficCalendar,
},
data() {
    return {
        basisList:[],
        highList:[],
        annualList:[],
        annualFilterChecked: false,
        tab:1,
        dataList:[],
        showTrafficMonitor: false,
        showCopyPanelVisiable:false,
        copyPanelMk: "",
        copyPanelMkName: "",
        copyUrl: "",
        copyPanelTk: "",
        copyPanelCommonTk: "",
        copyPanelPro: "",
        certified: false,//是否已认证
        shadowTip:false,
        showFreePackageDialog: false,
        showSuccessDialog: false,
        agreedTerms: false,
        showFlowSettingDialog: false,
        flowProtectionMode: 'continuous',
        flowSettingLoading: false,
        authLetterModalVisible:false,
        authLetterModalMode:"initial",
        enterpriseCertInfoId:null,
        authorizationLetterRejectReason:"",
        authLetterPendingFile:null,
        authLetterPendingName:"",
        authLetterUploading:false,
        authLetterDragOver:false,
        authLetterCompanyName:"",
        authLetterCreditCode:"",
        authLetterTemplateLoading:false,
        authLetterTopTip:"",
        authLetterTopTipType:"success",
    }
},
watch: {
    '$route'(to) {
        if (to.name === 'rsManage' && to.hash === '#source-list-section') {
            this.applySourceListAnchorIfNeeded();
        }
    },
    annualFilterChecked() {
        this.fetchImageryListByTab();
    },
},
created(){
    if (!localStorage.getItem("userId")) {
        const base = (this.$router && this.$router.options && this.$router.options.base) || "/rskit";
        const fromPath = String(base).replace(/\/$/, "") + (this.$route.fullPath || "/rsManage");
        const backUrl = rootUrl + fromPath;
        window.open(
            rootUrl + "/Login?fromUrl=" + encodeURIComponent(backUrl),
            "_self"
        );
        return;
    }
    this.checkRealNameBeforeEnter();
},
mounted() {
    if (!localStorage.getItem("userId")) {
        return;
    }
    this.getTk()
    if (this.$route.hash === '#source-list-section') {
        this.applySourceListAnchorIfNeeded();
    } else if (this.$route.hash === '#flow-setting') {
        this.openTrafficSetting();
    } else {
        document.getElementById("barId").scrollIntoView({ behavior: "instant" });
    }
},
computed: {
    authLetterTitle() {
        if (this.authLetterModalMode === "pending") return "授权委托书审核中";
        return "上传授权委托书";
    },
    authLetterBodyText() {
        if (this.authLetterModalMode === "pending") {
            return "您上传的授权委托书正在审核中，请耐心等待。";
        }
        return "根据平台管理要求，机构企业用户购买遥感商城产品需要签署授权委托书并盖章上传，审核通过后可享受专属购买权益。";
    },
    authLetterPrimaryLabel() {
        return this.authLetterModalMode === "initial" ? "确认上传" : "重新上传";
    },
},
methods:{
    /** 从外链进入 /rsManage#source-list-section：按 query.sourceTab 切 Tab 并滚到「图源列表」 */
    applySourceListAnchorIfNeeded() {
        if (this.$route.hash !== '#source-list-section') return;
        const targetTab = Number(this.$route.query.sourceTab) === 2 ? 2 : 1;
        if (this.tab !== targetTab) {
            this.tab = targetTab;
            this.fetchImageryListByTab();
        }
        this.$nextTick(() => {
            const el = document.getElementById('source-list-section');
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    },
    getKey() {
        return localStorage.getItem("token");
    },
    /**
     * 影像拆分：带当前 Tab 对应 basic/premium 与 mk id，供目标页预填弹窗。
     * preset：包年/二级行在 series 一级列表里可能无此项，需传 name（及 iv）供目标页展示与 mk_ids。
     */
    goImageSegmentationWithMk(mkId, preset) {
        // debugger
        if (!this.certified) {
            this.verifyUserCertification()
            return
        }
        const type = this.tab === 2 ? "premium" : "basic";
        const query = { id: String(mkId), type };
        if (preset && preset.name) {
            query.presetName = preset.name;
        }
        if (preset && preset.iv) {
            query.presetIv = preset.iv;
        }
        if (preset && preset.pro) {
            query.presetPro = preset.pro;
        }
        if (preset && preset.tk) {
            query.presetTkIv = preset.tk;
        }
        if (preset && preset.isAnnual) {
            query.presetIsAnnual = preset.isAnnual;
        }
        if (preset && preset.annualId) {
            query.presetAnnualId = preset.annualId;
        }
        this.$router.push({
            path: "/imageSegmentation",
            query,
        });
    },
    goImageSegmentationAll() {
        if (!this.certified) {
            this.verifyUserCertification()
            return
        }
        this.$router.push('/imageSegmentation')
    },
    //带权限判断的跳转
    jumpWithPermission(type,path,fromUrl,mapImage){
        //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
        //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
        let loginUserId=localStorage.getItem('userId');//是否已登录
        let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        if(type=='可游客'){
            if(fromUrl){
                window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
                window.open(rootUrl+path,"_self")
            }
        }else if(type=='仅登录'){
            //已登录
            if (loginUserId) {
                let url=''
                if(fromUrl){
                    url=rootUrl+path+"?fromUrl="+rootUrl+fromUrl
                }
                else {
                    url=rootUrl+path
                }
                if (mapImage&&mapImage.id) {
                    url = `${url}&path=${mapImage.path}&type=${mapImage.type}&id=${mapImage.id}`
                    // 拆分图源(包年)额外携带 annualId/pro，供实验室按唯一标识精确定位并加载 geojson
                    if (mapImage.annualId) {
                        url += `&annualId=${mapImage.annualId}`
                    }
                    if (mapImage.pro) {
                        url += `&pro=${mapImage.pro}`
                    }
                }
                window.open(url,"_blank")
            }
            //未登录
            else {
                if(fromUrl){
                    window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+'/Login',"_self")
                }
            }
        }else if(type=='仅实名'){
            //已登录
            if(loginUserId){
                //已实名
                if(authentication=='0'){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未实名
                else {
                    window.open(rootUrl+'/Authentication',"_self")
                }

            }
            //未登录
            else {
                if(fromUrl){
                    window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+'/Login',"_self")
                }
            }
        }
    },
    checkAndHandleAuthentication(){
        let loginUserId=localStorage.getItem('userId');//是否已登录
        let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        if(!loginUserId){
        this.jumpWithPermission('仅登录','/Login','/rskit/')
        }
        else if(authentication!='0'){
        this.jumpWithPermission('仅实名','/Authentication','/rskit/')
        }
        return true;
    },
    /**
     * 进入本页前的实名校验：未登录→登录页，未实名→实名页，已实名才加载页面数据。
     * 优先用 /loginapi/getLoginInfo 取最新实名状态（避免本地缓存过期/缺失误判），
     * 接口异常时回退到 localStorage 中的 authentication。
     */
    checkRealNameBeforeEnter() {
        const backUrl = "/rskit" + (this.$route.fullPath || "/rsManage");
        this.axios
            .get("/loginapi/getLoginInfo", {
                headers: { Authorization: "Bearer " + this.getKey() },
            })
            .then((res) => {
                const body = res && res.data;
                if (body && body.success && body.data) {
                    const authentication = String(body.data.authentication);
                    localStorage.setItem("authentication", authentication);
                    if (authentication !== "0") {
                        // 未实名 → 实名页
                        this.jumpWithPermission("仅实名", "/Authentication", backUrl);
                        return;
                    }
                    // 已实名 → 加载页面数据
                    this.loadPageDataAfterAuth();
                } else {
                    // 登录态失效 → 登录页
                    this.jumpWithPermission("仅登录", "/Login", backUrl);
                }
            })
            .catch(() => {
                // 接口异常：回退到本地缓存的实名状态
                const authentication = localStorage.getItem("authentication");
                if (authentication !== "0") {
                    this.jumpWithPermission("仅实名", "/Authentication", backUrl);
                    return;
                }
                this.loadPageDataAfterAuth();
            });
    },
    loadPageDataAfterAuth() {
        this.initExpandState(this.dataList);
        this.fetchUserTrafficPackageInfo();
        this.fetchUserAnnualTrafficInfo();
        this.fetchImageryListByTab();
    },
    initExpandState(items) {
        items.forEach(item => {
            // 判断是否有子列表
            const hasChildren = item.list || item.photoList;
            if (hasChildren) {
            this.$set(item, 'expanded', true); // 默认收起
            }

            // 递归处理子项
            if (item.list) {
            this.initExpandState(item.list);
            }
            if (item.photoList) {
            this.initExpandState(item.photoList);
            }
        });
    },
    toggleExpand(item) {
        // 只有当有子列表时才允许切换
        const hasChildren = item.list || item.photoList;
        if (hasChildren) {
            this.$set(item, 'expanded', !item.expanded);
        }
    },
    /**
     * 拉取流量包信息：先调用 checkTodayFreePackage（最多等待 1 秒），
     * 待其返回或超时后再执行原有拉取逻辑。
     */
    async fetchUserTrafficPackageInfo(){
        await this.checkTodayFreePackage();
        try {
            const res = await this.axios.get('/tileflowapi/flow/package/getUserTrafficPackageInfo', {
                headers: {
                    Authorization: 'Bearer ' + this.getKey(),
                },
            });
            const body = res && res.data;
            if (body && Number(body.code) === 200 && body.data) {
                this.basisList = body.data.basic || [];
                this.highList = body.data.premium || [];
            } else {
                this.basisList = [];
                this.highList = [];
            }
        } catch (e) {
            this.basisList = [];
            this.highList = [];
        }
    },
    fetchUserAnnualTrafficInfo(){
        this.axios.get('/tileflowapi/flow/package/getUserAnnualTrafficInfo', {
            headers: {
                Authorization: 'Bearer ' + this.getKey(),
            },
        }).then((res) => {
            const body = res && res.data;
            if (body && Number(body.code) === 200 && Array.isArray(body.data)) {
                this.annualList = body.data;
            } else {
                this.annualList = [];
            }
        }).catch(() => {
            this.annualList = [];
        });
    },
    /** 包年卡"已用"位置文案：status 2=已过期，3=今日已耗尽，其他=已用X次 */
    annualUsedText(item) {
        if (!item) return "";
        const s = Number(item.status);
        if (s === 2) return "已过期";
        if (s === 3) return "今日已耗尽";
        return "已用" + Math.ceil(Number(item.usedCount)) + "次";
    },
    getUsagePercent(item){
        if (!item) return 0;
        const total = Number(item.flowSum || 0);
        const used = Number(item.usedCount || 0);
        if (!total || total <= 0) return 0;
        let percent = (used / total) * 100;
        if (percent < 0) percent = 0;
        if (percent > 100) percent = 100;
        return Math.round(percent);
    },
    /** 与「次日重置」同位置的副标题：免费固定次日重置；付费包按 status 2/3 显示已过期/已耗尽 */
    flowStatusSubtitle(item) {
        if (!item) return "";
        if (item.flowType == "free") return "仅用于体验图源";
        const s = Number(item.status);
        if (s === 2) return "已过期";
        if (s === 3) return "已耗尽";
        return "";
    },
    openTrafficMonitor(){
        console.log(111);

        this.showTrafficMonitor = true;
    },
    openTrafficSetting(){
        this.showFlowSettingDialog = true;
        this.fetchFlowProtection();
    },
    fetchFlowProtection(){
        this.axios.get('/tileflowapi/flow/package/getFlowProtection', {
            headers: { Authorization: 'Bearer ' + this.getKey() },
        }).then((res) => {
            const body = res && res.data;
            if (body && Number(body.code) === 200 && body.data !== undefined && body.data !== null) {
                this.flowProtectionMode = body.data === true ? 'protect' : 'continuous';
            }
        }).catch(() => {});
    },
    closeFlowSetting(){
        this.showFlowSettingDialog = false;
    },
    saveFlowSetting(){
        if (this.flowSettingLoading) return;
        const protect = this.flowProtectionMode === 'protect';
        this.flowSettingLoading = true;
        this.axios.post('/tileflowapi/flow/package/setFlowProtection', null, {
            params: { protect: protect },
            headers: { Authorization: 'Bearer ' + this.getKey() },
        }).then((res) => {
            const body = res && res.data;
            if (body && Number(body.code) === 200) {
                this.$message.success('更改成功');
                this.showFlowSettingDialog = false;
            }
        }).catch(() => {}).finally(() => {
            this.flowSettingLoading = false;
        });
    },
    switchDataTab(tab){
        if (this.tab === tab) return;
        this.tab = tab;
        this.fetchImageryListByTab();
    },
    fetchImageryListByTab(){
        const type = this.tab === 1 ? 'basic' : 'premium';
        const mkTypeText = this.tab === 1 ? '基础图源' : '高级图源';
        const purchasedOnly = this.annualFilterChecked;
        this.axios.get(`/tileflowapi/imagery/mk/list?type=${type}&callScenario=external&purchasedOnly=${purchasedOnly}`, {
            headers: {
                Authorization: 'Bearer ' + this.getKey(),
            },
        }).then((res) => {
            const body = res && res.data;
            if (body && Number(body.code) === 200 && Array.isArray(body.data)) {
                this.dataList = this.formatImageryDataList(body.data, mkTypeText);
                // debugger
                this.initExpandState(this.dataList);
            } else {
                this.dataList = [];
            }
        }).catch(() => {
            this.dataList = [];
        });
    },
    formatImageryDataList(rawList, mkTypeText){
        return (rawList || []).map((series, index) => {
            const path = `${index}`;
            return {
            name: folderMapping[series.series]|| series.name || '',
            list: Array.isArray(series.value)
                ? series.value.map((node,index1) => this.mapImageryNode(node, mkTypeText, 1, path+`-${index1}`))
                : [],
            }
        });
    },
    mapImageryNode(node, mkTypeText, depth, path) {
        // debugger
        const children = Array.isArray(node && node.value) ? node.value : [];
        const item = {
            id: (node && node.id) || '',
            iv: (node && node.iv) || '',
            name: (node && node.name) || '',
            imageGsd: this.formatResolution(node && node.resolution),
            type: mkTypeText,
            year: Boolean(node && node.isAnnual),
            url: '',
            tk: (node && node.tk) || '',
            sk: (node && node.sk) || '',
            pro: (node && node.pro) || '',
            needSk: node && node.needSk,
            path: path,
            annualId: (node && node.annualId) || '',
            isAnnual: (node && node.isAnnual) || false,
        };
        if (children.length) {
            const mappedChildren = children.map((child,index2) => this.mapImageryNode(child, mkTypeText, depth + 1,path+`-${index2}`));
            if (depth === 1) {
                item.photoList = mappedChildren;
            } else {
                item.list = mappedChildren;
            }
        }
        return item;
    },
    formatResolution(resolution){
        if (resolution === null || resolution === undefined || resolution === '') {
            return '';
        }
        return `${resolution}m分辨率`;
    },

    showCopyPanel(mk, mkName, tk, pro) {
      if ((tk === null || tk === '') && (this.copyPanelCommonTk === null || this.copyPanelCommonTk === '')) {
        this.shadowTip = true;
        return
      }
      this.copyPanelMk=mk
      this.copyPanelMkName=mkName
      this.copyPanelTk=tk
      this.copyPanelPro=pro
      this.showCopyPanelVisiable = true
    },
    // type 1场景1 2场景2 3场景3 4场景4(ArcMap/ArcGIS Pro - getCapabilities)
    copyAddress(type) {
        if (type === 4) {
            let url = `https://api.jl1mall.com/getCapabilities?mk=${this.copyPanelMk}&tk=${this.copyPanelTk!=''?this.copyPanelTk:this.copyPanelCommonTk}`
            if (this.copyPanelPro != '') {
                url = url + `&pro=${this.copyPanelPro}`
            }
            this.copyUrl = url + '&flow=true'
            this.copy()
            return
        }
        let y = ''
        switch (type) {
            case 1:
                y='{-y}'
                break;
            case 2:
                y='{reverseY}'
                break;
            case 3:
                y='{y}'
                break;
            default:
                y='{-y}'
                break;
        }
        this.copyUrl = `https://api.jl1mall.com/getTile/{z}/{x}/${y}?mk=${this.copyPanelMk}&tk=${this.copyPanelTk!=''?this.copyPanelTk:this.copyPanelCommonTk}`
        if (this.copyPanelPro!='') {
            this.copyUrl = this.copyUrl + `&pro=${this.copyPanelPro}`
        }
        this.copy()
    },
    copy(){
        var clipboard = new Clipboard("#keyIconId")
        clipboard.on("success", e => {
        alert("复制链接成功！");
        clipboard.destroy()
        })
        clipboard.on("error", e => {
            alert("复制失败！");
            // 释放内存
            clipboard.destroy()
        })
    },
    readMoreKey(){
        window.open("https://files.jl1mall.com/tiles/%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C/%E5%90%89%E6%9E%97%E4%B8%80%E5%8F%B7%E5%88%87%E7%89%87%E5%BD%B1%E5%83%8F%E5%A5%97%E4%BB%B6%E7%AC%AC%E4%B8%89%E6%96%B9%E5%B7%A5%E5%85%B7%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E9%80%9F%E8%AF%BB.pdf")
    },
    getTk() {
      this.axios.get("/tileflowapi/imagery/getUserTk", {
        params: { callScenario: "external" },
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      }).then(res => {
        if (res.data.code==200) {
          this.certified = res.data.data.certified
          this.copyPanelCommonTk = res.data.data.tk
        }
      });
    },

    authentication(path) {
        window.open(rootUrl+path,'_self')
    },
    /**
     * 检查今日是否已领取免费流量包：仅调用接口，不处理返回结果，最多等待 1 秒。
     * 本方法必定 resolve，失败或超时都不会阻断后续的流量包拉取。
     */
    async checkTodayFreePackage(){
      // 1 秒后自动 resolve，作为等待上限的兜底
      const timeout = new Promise((resolve) => setTimeout(resolve, 1000));
      // 实际请求：正常返回与失败都 resolve，是否等待交给下方 race 决定；
      // catch 挂在原请求上，避免超时放弃等待后产生未处理的 Promise 拒绝
      const request = this.axios.get('/tileflowapi/flow/package/checkTodayFreePackage', {
        headers: {
          Authorization: 'Bearer ' + this.getKey(),
        },
      }).catch(() => {});
      // 请求先返回、或 1 秒先超时，谁先落定算谁
      await Promise.race([request, timeout]);
    },
    // 点击"立即领取"按钮
    handleClaim(){
      if (!this.agreedTerms) return;
      // 实名校验
      let authentication = localStorage.getItem('authentication');
      if (authentication !== '0') {
        // 未实名，设置待领取标记后跳转实名认证页面
        localStorage.setItem('pendingFreeClaim', 'true');
        const base = (this.$router && this.$router.options && this.$router.options.base) || "/rskit";
        const backUrl = rootUrl + String(base).replace(/\/$/, "") + '/rsManage';
        window.open(rootUrl + '/Authentication?fromUrl=' + encodeURIComponent(backUrl), '_self');
        return;
      }
      this.doClaimFreePackage();
    },
    // 调用领取接口
    doClaimFreePackage(){
      this.axios.post('/tileflowapi/flow/package/claimFreePackage', null, {
        headers: {
          Authorization: 'Bearer ' + this.getKey(),
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.showFreePackageDialog = false;
          this.showSuccessDialog = true;
          this.fetchUserTrafficPackageInfo();
        }
      });
    },
    // 成功弹窗"立即前往"：关闭弹窗并下滑至图源列表
    scrollToSourceList(){
      this.showSuccessDialog = false;
      this.$nextTick(() => {
        const el = document.getElementById('source-list-section');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    openPDF(){
        window.open("https://files.jl1mall.com/jl1store/document/吉林一号在线访问产品使用协议.pdf")
    },
    verifyUserCertification() {
        this.axios.get("/loginapi/getUserForUserCenter", {
            headers: {
                Authorization: "Bearer " + this.getKey(),
            },
        }).then((res) => {
            if (res.status == 200) {
                const d = res.data && res.data.data;
                if (!d) {
                    alert("系统错误");
                    return;
                }
                const certificationIdentityWithoutLetter = String(d.certificationIdentityWithoutLetter);
                if (certificationIdentityWithoutLetter === "2" || certificationIdentityWithoutLetter === "3") {
                    this.completeCertification();
                }else{
                  this.shadowTip = true;
                }
                // const ecRaw = d.enterpriseCertStatus;
                // const ecStr = ecRaw === null || ecRaw === undefined || ecRaw === "" ? "" : String(ecRaw).trim();
                // if (ecStr === "" || ecStr === "null") {
                //     this.shadowTip = true;
                //     return;
                // }
                // if (ecStr === "1") {
                //     this.jumpWithPermission("仅实名", "/store/VIPBenefits", "/rskit" + this.$route.fullPath);
                //     return;
                // }
                // if (ecStr === "0" || ecStr === "2" || ecStr === "3") {
                //     this.loadEnterpriseCertInfo();
                // } else {
                //     this.shadowTip = true;
                // }
            } else {
                alert("系统错误");
            }
        }).catch(() => {
            alert("系统错误");
        });
    },
    completeCertification() {
        this.certified = true;
        this.shadowTip = false;
        this.authLetterModalVisible = false;
        this.clearAuthFile();
        this.clearAuthLetterTip();
        this.showValidationTip("认证成功，请重新操作");
    },
    showValidationTip(msg) {
        alert(msg);
    },
    mapAuthorizationLetterView(statusRaw) {
        if (statusRaw === null || statusRaw === undefined || statusRaw === "") return "initial";
        const t = String(statusRaw).trim();
        if (t === "null" || t === "undefined") return "initial";
        if (t === "未通过" || t.includes("未通过")) return "rejected";
        if (t === "审核中" || t.includes("审核中")) return "pending";
        if (t === "已通过" || t.includes("已通过")) return "proceed";
        if (t === "0" || t === 0) return "initial";
        if (t === "1" || t === 1) return "pending";
        if (t === "2" || t === 2) return "proceed";
        if (t === "3" || t === 3) return "rejected";
        return "initial";
    },
    loadEnterpriseCertInfo() {
        this.axios
            .get("/accessapi/enterprise/cert/getUserEnterpriseCertInfo", {
                headers: { Authorization: "Bearer " + this.getKey() },
            })
            .then((res) => {
                const body = res.data;
                const data = (body && (body.data !== undefined ? body.data : body)) || {};
                this.enterpriseCertInfoId = data.id != null ? data.id : (data.certId != null ? data.certId : null);
                this.authLetterCompanyName = (data.companyName != null ? data.companyName : "").toString().trim();
                this.authLetterCreditCode = (data.creditCode != null ? data.creditCode : "").toString().trim();
                this.authorizationLetterRejectReason = (
                    data.authorizationLetterRejectReason
                    || data.rejectReason
                    || data.refuseReason
                    || data.authorizationRefuseReason
                    || ""
                ).toString().trim();
                this.clearAuthFile();
                this.clearAuthLetterTip();
                const mode = this.mapAuthorizationLetterView(data.authorizationLetterStatus);
                if (mode === "proceed") {
                    this.completeCertification();
                    return;
                }
                this.authLetterModalMode = mode;
                this.authLetterModalVisible = true;
            })
            .catch(() => {
                this.showValidationTip("获取企业认证信息失败");
            });
    },
    showAuthLetterTip(msg, type) {
        this.authLetterTopTip = msg || "";
        this.authLetterTopTipType = type === "success" ? "success" : "error";
    },
    clearAuthLetterTip() {
        this.authLetterTopTip = "";
    },
    closeAuthLetterModal() {
        this.authLetterModalVisible = false;
        this.clearAuthFile();
        this.clearAuthLetterTip();
    },
    openAuthFilePicker() {
        if (this.$refs.authFileInput) {
            this.$refs.authFileInput.value = "";
            this.$refs.authFileInput.click();
        }
    },
    triggerAuthFileInput() {
        this.openAuthFilePicker();
    },
    onAuthDragOver() {
        this.authLetterDragOver = true;
    },
    onAuthDragLeave() {
        this.authLetterDragOver = false;
    },
    onAuthFileDrop(e) {
        this.authLetterDragOver = false;
        const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        this.applyAuthPickedFile(f);
    },
    onAuthFileChange(e) {
        const f = e.target && e.target.files && e.target.files[0];
        this.applyAuthPickedFile(f);
    },
    applyAuthPickedFile(file) {
        if (!file) return;
        this.authLetterPendingFile = file;
        this.authLetterPendingName = file.name;
    },
    clearAuthFile() {
        this.authLetterPendingFile = null;
        this.authLetterPendingName = "";
        if (this.$refs.authFileInput) {
            this.$refs.authFileInput.value = "";
        }
    },
    isAuthFileValidType(file) {
        if (!file || !file.name) return false;
        const n = file.name.toLowerCase();
        return n.endsWith(".pdf") || n.endsWith(".jpg") || n.endsWith(".jpeg") || n.endsWith(".png");
    },
    validateAuthFileForUpload() {
        const f = this.authLetterPendingFile;
        if (!f) {
            this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            return false;
        }
        const maxBytes = 20 * 1024 * 1024;
        if (f.size > maxBytes) {
            this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            return false;
        }
        if (!this.isAuthFileValidType(f)) {
            this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            return false;
        }
        return true;
    },
    downloadAuthLetterTemplate() {
        if (this.authLetterTemplateLoading) {
            return;
        }
        const name = (this.authLetterCompanyName || "").trim();
        const code = (this.authLetterCreditCode || "").trim();
        if (!name || !code) {
            this.showAuthLetterTip("企业名称或统一社会信用代码缺失，请刷新页面后重试", "error");
            return;
        }
        this.authLetterTemplateLoading = true;
        this.clearAuthLetterTip();
        const fd = new FormData();
        fd.append("companyName", name);
        fd.append("creditCode", code);
        this.axios
            .post("/accessapi/enterprise/cert/getAuthorizationLetter", fd, {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((res) => {
                const body = res.data || {};
                if (body.status === 200 && body.data) {
                    const url = typeof body.data === "string" ? body.data : (body.data.url || body.data);
                    if (url) {
                        window.open(url, "_blank");
                    } else {
                        this.showAuthLetterTip("未获取到模板地址", "error");
                    }
                } else {
                    this.showAuthLetterTip(
                        (body.message && String(body.message)) || "获取模板失败，请稍后重试",
                        "error",
                    );
                }
            })
            .catch(() => {
                this.showAuthLetterTip("获取模板失败，请稍后重试", "error");
            })
            .finally(() => {
                this.authLetterTemplateLoading = false;
            });
    },
    postAuthorizationLetter() {
        if (!this.enterpriseCertInfoId) {
            this.showAuthLetterTip("企业认证信息不完整，请刷新页面后重试", "error");
            return;
        }
        if (!this.validateAuthFileForUpload()) return;
        this.clearAuthLetterTip();
        const fd = new FormData();
        fd.append("id", this.enterpriseCertInfoId);
        fd.append("authorizationLetter", this.authLetterPendingFile);
        this.authLetterUploading = true;
        this.axios
            .post("/accessapi/enterprise/cert/uploadAuthorizationLetter", fd, {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((res) => {
                const d = res.data || {};
                if (d.status != null && d.status !== 200) {
                    this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                    return;
                }
                if (d.code != null && d.code !== 200 && d.code !== 0) {
                    this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                    return;
                }
                if (d.success === false) {
                    this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                    return;
                }
                this.showValidationTip("上传成功，预计在1-3个工作日内完成审核");
                this.closeAuthLetterModal();
            })
            .catch(() => {
                this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            })
            .finally(() => {
                this.authLetterUploading = false;
            });
    },
    confirmAuthLetterAction() {
        if (this.authLetterUploading) return;
        this.postAuthorizationLetter();
    },
    openFile(i){
        if(i==1){
            window.open("https://files.jl1mall.com/jl1store/document/在线地图访问常见问题帮助文档.pdf")
        }else if(i==2){
            window.open("https://files.jl1mall.com/tiles/%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C/%E5%90%89%E6%9E%97%E4%B8%80%E5%8F%B7%E5%88%87%E7%89%87%E5%BD%B1%E5%83%8F%E5%A5%97%E4%BB%B6Web%E7%AB%AF%E5%B7%A5%E5%85%B7%E9%9B%86SDK_V1.0.0_%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf")
        }else if(i==3){
            window.open("https://files.jl1mall.com/tiles/%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C/%E5%90%89%E6%9E%97%E4%B8%80%E5%8F%B7%E5%88%87%E7%89%87%E5%BD%B1%E5%83%8F%E5%A5%97%E4%BB%B6%E7%A7%BB%E5%8A%A8%E7%AB%AF%E5%B7%A5%E5%85%B7%E9%9B%86SDK_V1.0.0_%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf")
        }else if(i==4){
            window.open("https://files.jl1mall.com/jl1store/document/吉林一号在线地图访问使用说明书.pdf")
        }
    }
}
}
</script>
<style scoped>
.bar{
position: relative;
width: 100%;
height: 1px;
background-color: #fff;
}
.background{
position: relative;
margin-top: 96px;
margin-left: calc(50% - 588px);
width: 1176px;
min-height: 500px;
height: auto;
background: #F7FAFD;
border-radius: 12px;
overflow: hidden;
margin-bottom: 100px;
}
.myData{
position: relative;
margin-top: 48px;
width: 100%;
height: 64px;
}
.dataText1{
position: absolute;
top: 16px;
width:100%;
height: 32px;
font-family: PingFangSC, PingFang SC;
font-weight:600;
font-size: 24px;
color: rgba(0,0,0,0.85);
line-height: 32px;
text-align: center;
}
.dataIcon1{
position: absolute;
top: 0;
left: calc(50% - 32px);
width: 64px;
}
.dataLine1{
position: absolute;
top: 32px;
left: 40px;
width: 500px;
height: 1px;
border-top: 1px dashed #979797;
}
.dataLine2{
position: absolute;
top: 32px;
right: 288px;
width: 252px;
height: 1px;
border-top: 1px dashed #979797;
}
.dataIcon2{
position: absolute;
top: 24px;
right: 112px;
width: 16px;
cursor: pointer;
}
/* 流量使用设置：复用流量监控 icon，置于其左侧，末字距流量监控 icon 24px */
.dataIcon2b{
right: 256px;
}
.dataText2{
position: absolute;
top: 21px;
right: 40px;
width: auto;
height: 22px;
font-family: PingFangSC, PingFang SC;
font-weight:600;
font-size: 16px;
color: #1890FF;
line-height: 22px;
text-align: left;
cursor: pointer;
}
.dataText2b{
right: 152px;
width: 96px;
text-align: right;
}
.basisData{
position: relative;
margin-top: 24px;
margin-left: 40px;
width: 500px;
height: 28px;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 20px;
color: rgba(0,0,0,0.85);
line-height: 28px;
text-align: left;
}
.basisText1{
position: absolute;
top: 0;
left: 124px;
width: auto;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 16px;
color: #1890FF;
line-height: 28px;
cursor: pointer;
}
.basisCtn{
position: relative;
width: 1136px;
min-height: 164px;
height: auto;
margin-top: 24px;
margin-left: 40px;
overflow: hidden;
}
.premuimText1{
position: absolute;
top: 140px;
left: 476px;
width:auto;
height: 22px;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 16px;
color: #8C8C8C;
line-height: 22px;
}
.basisListCtn{
position: relative;
margin-right: 20px;
margin-bottom: 20px;
display: inline-block;
width: 352px;
height: 164px;
background: #FFFFFF;
box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.08);
border-radius: 12px;
border: 1px solid #E8E8E8;
}
.basisIcon1{
position: absolute;
width: 32px;
top: 24px;
left: 24px;
}
.basisText2{
position: absolute;
top: 28px;
left: 72px;
width: auto;
height: 24px;
font-family: "PingFangSC-Medium", PingFangSC, PingFang SC;
font-weight: 500;
font-size: 16px;
color: rgba(0,0,0,0.65);
line-height: 24px;
}
.basisText3{
position: absolute;
top: 30px;
right: 24px;
width: auto;
height: 20px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: rgba(0,0,0,0.65);
line-height: 20px;
}
.basisText4{
position: absolute;
top: 80px;
left: 24px;
width: auto;
height: 22px;
font-family: "PingFangSC-Medium", PingFangSC, PingFang SC;
font-weight: 500;
font-size: 14px;
color: rgba(0,0,0,0.65);
line-height: 22px;
}
.basisText5{
position: absolute;
top: 80px;
right: 24px;
width: auto;
height: 22px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: rgba(0,0,0,0.65);
line-height: 22px;
text-align: right;
}
.basisText7{
position: absolute;
top: 122px;
left: 24px;
width: auto;
height: 22px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: rgba(0,0,0,0.65);
line-height: 22px;
}
/* 图源包年流量：购买链接右移，避免与6字标题挤在一起 */
.annualPurchaseLink{
left: 168px;
}
/* 图源包年流量：到期时间换行下移，避免与服务区域重叠 */
.annualExpireTime{
top: 148px;
}
/* 图源包年流量：卡片加高，容纳服务区域+到期时间两行 */
.annualListCtn{
width: 352px;
height: 180px;
}
/* 图源包年流量：图源名称用苹方medium */
.annualText2{
font-family: "PingFangSC-Medium", PingFangSC, PingFang SC;
font-weight: 500;
}
/* 图源包年流量：服务区域最大宽度304，超出省略 */
.annualRegion{
width: 304px;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}
/* 仅查看已购包年图源：勾选框+文字，距胶囊32px，垂直居中 */
.annualFilter{
position: absolute;
left: 456px;
top: 20px;
height: 16px;
display: flex;
align-items: center;
}
/* 覆盖 a-checkbox 尺寸为 16px，保持对号显示 */
.annualFilter .annualFilterBox.ant-checkbox-wrapper{
margin: 0;
padding: 0;
}
.annualFilter .ant-checkbox{
width: 16px;
height: 16px;
top: 0;
}
.annualFilter .ant-checkbox-inner{
width: 16px;
height: 16px;
border-radius: 2px;
}
.annualFilterText{
margin-left: 8px;
width: 126px;
height: 22px;
font-family: "PingFangSC-Regular", PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: rgba(0,0,0,0.65);
line-height: 22px;
text-align: left;
font-style: normal;
}
/* 仅查看已购包年图源 + 无数据：空状态 */
.annualEmpty{
position: relative;
margin-top: 80px;
padding-bottom: 32px;
width: 100%;
text-align: center;
}
.annualEmptyImg{
display: block;
margin: 0 auto;
width: 100px;
height: 100px;
}
.annualEmptyText{
margin-top: 16px;
margin-left: auto;
margin-right: auto;
width: fit-content;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: rgba(0,0,0,0.65);
line-height: 22px;
}
.annualEmptyLink{
margin-top: 8px;
margin-left: auto;
margin-right: auto;
width: fit-content;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #2F54EB;
line-height: 22px;
cursor: pointer;
}
.basisLine1{
position: absolute;
top: 100px;
left: 24px;
width: 304px;
}
.listTab{
position: relative;
margin-top: 40px;
width:100%;
height: 56px;
}
.basisTab{
position: absolute;
left: 40px;
width: 192px;
height: 56px;
background: #1890FF;
border-radius: 8px 0px 0px 8px;
cursor: pointer;
}
.basisTab-s{
position: absolute;
left: 40px;
width: 192px;
height: 56px;
background: #FFFFFF;
border-radius: 8px 0px 0px 8px;
cursor: pointer;
}
.basisText6{
position: absolute;
top: 19px;
left: 80px;
font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 18px;
color: #FFFFFF;
line-height: 18px;
}
.basisText6-s{
position: absolute;
top: 19px;
left: 80px;
font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 18px;
color: #595959;
line-height: 18px;
}
.basisLine2{
position: absolute;
top: 42px;
left: 80px;
width: 72px;
height: 2px;
background: #FFFFFF;
}
.highTab{
position: absolute;
left: 232px;
width: 192px;
height: 56px;
background: rgba(255, 255, 255, 0.9);
border-radius: 0px 8px 8px 0px;
cursor: pointer;
}
.highTab-s{
position: absolute;
left: 232px;
width: 192px;
height: 56px;
background: rgba(114, 46, 209, 0.9);
border-radius: 0px 8px 8px 0px;
cursor: pointer;
}
</style>
<style scoped>
.listCtn{
position: relative;
margin-bottom: 32px;
width: 100%;
/* min-height: 100px; */
height: auto;
overflow: hidden;
}
.level1{
position: relative;
margin-left: 40px;
width: auto;
height: 28px;
/* margin-bottom: 24px; */
}
.levelText1{
float: left;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 20px;
color: rgba(0,0,0,0.85);
line-height: 28px;
}
.levelIcon1{
float: left;
margin-top: 3px;
margin-left: 24px;
cursor: pointer;
}
.level2{
position: relative;
margin-left: 40px;
margin-top: 16px;
width: 1096px;
height: 72px;
background: #FFFFFF;
box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.05);
border-radius: 8px;
}
.levelText2{
float: left;
margin-left: 40px;
margin-right: 24px;
width: auto;
height: 72px;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 16px;
color: rgba(0,0,0,0.85);
line-height: 72px;
}
.levelLabel1{
float: left;
margin-right: 16px;
margin-top: 25px;
width: 64px;
height: 22px;
background: #F5F5F5;
border-radius: 4px;
border: 1px solid #D9D9D9;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 12px;
color: rgba(0,0,0,0.65);
line-height: 22px;
text-align: center;
}
.levelIcon2{
position: absolute;
top: 26px;
right: 40px;
width: 16px;
height: 16px;
cursor: pointer;
}
.levelLabel3{
position: absolute;
top: 20px;
right: 96px;
width: 88px;
height: 32px;
background: #FFFFFF;
border-radius: 4px;
border: 1px solid rgba(0,0,0,0.15);
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: rgba(0,0,0,0.65);
line-height: 32px;
text-align: center;
cursor: pointer;
}
.levelLabel4{
position: absolute;
top: 20px;
right: 304px;
width: 88px;
height: 32px;
background: #1890FF;
border-radius: 4px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #FFFFFF;
line-height: 32px;
text-align: center;
cursor: pointer;
}
.level3Ctn{
position: relative;
width: 1063px;
height: auto;
margin-left: 72px;
border-left:1px solid  #E8E8E8;
overflow: hidden;
}
.level3{
position: relative;
margin-top: 12px;
margin-left: 16px;
width: 1023px;
height: 38px;
background: #FAFAFA;
box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.05);
border-radius: 6px;
}
.levelText3{
float: left;
margin-left: 24px;
margin-right: 24px;
width: auto;
height: 38px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: rgba(0,0,0,0.65);
line-height: 38px;
}
.levelLabel2{
float: left;
margin-top: 8px;
margin-right: 16px;
width: 64px;
height: 22px;
background: #E6F7FF;
border-radius: 4px;
border: 1px solid #91D5FF;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 12px;
color: #1890FF;
line-height: 22px;
text-align: center;
}
.levelLabelExperience{
float: left;
margin-right: 16px;
margin-top: 25px;
width: 64px;
height: 22px;
background: #F6FFED;
border-radius: 4px;
border: 1px solid #B7EB8F;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 12px;
color: #52C41A;
line-height: 22px;
text-align: center;
}
.levelLabel2Premium{
background: #F9F0FF;
border: 1px solid #D3ADF7;
color: #722ED1;
}
.levelLabel5{
float: right;
margin-left: 16px;
margin-top: 8px;
width: 72px;
height: 24px;
background: #FFFFFF;
border-radius: 4px;
border: 1px solid rgba(0,0,0,0.15);
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: rgba(0,0,0,0.65);
line-height: 24px;
text-align: center;
cursor: pointer;
}
.level4{
position: relative;
margin-top: 12px;
margin-left: 40px;
width: 975px;
height: 38px;
background: #FAFAFA;
box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.05);
border-radius: 6px;
}
.wordCtn{
position: relative;
margin-top: 16px;
margin-left: 64px;
height: 290px;
width: 1090px;
margin-bottom: 30px;
}
.wordBlock{
position: relative;
float: left;
margin-right: 40px;
margin-bottom: 16px;
width: 504px;
height: 80px;
background: #FFFFFF;
border-radius: 8px;
}
.wordIcon{
position: absolute;
top: 24px;
left: 24px;
width: 32px;
}
.wordText1{
position: absolute;
top: 16px;
left: 80px;
width: auto;
height: 24px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 16px;
color: rgba(0,0,0,0.65);
line-height: 24px;
}
.wordText2{
position: absolute;
top: 44px;
left: 80px;
width: auto;
height: 20px;
font-family: PingFangSC, PingFang SC;
font-weight: 300;
font-size: 12px;
color: rgba(0,0,0,0.65);
line-height: 20px;
}
.wordBtn1{
position: absolute;
top: 25px;
right: 32px;
width: 60px;
height: 30px;
border-radius: 4px;
border: 1px solid #1890FF;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #1890FF;
line-height: 30px;
text-align: center;
cursor: pointer;
}
</style>
<style lang="scss" scoped>
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent1{
    position: fixed;
    top: calc(50% - 200px);
    left: calc(50% - 400px);
    width: 800px;
    height: 400px;
    background: #FFFFFF;
    border-radius: 12px;
    .tips{
        position: absolute;
        left: 74px;
        font-size: 14px;
        // font-family: PingFangSC-Regular, PingFang SC;
        // font-weight: 400;
        color: #000000;
        line-height: 30px;
    }
    .address{
        position: absolute;
        left: 74px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 30px;
        width: 660px;
        height: 100px;
        display: flex;
        align-items: center;
        .mark{
            width: 536px;
            height: 100px;
            background: #F2F2F2;
            border-radius: 8px;
            padding: 5px 15px;
            .allKey{
                width: 500px;
                display: block;
                word-wrap: break-word;
                .key{
                    color: #0066CC;
                }
            }
        }
        .copyBtn{
            width: 96px;
            height: 40px;
            background: #0066CC;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #FFFFFF;
            margin-left: 20px;
            cursor: pointer;
        }
    }
    .readMore{
        position:absolute;
        top: 730px;
        left: 74px;
        font-size: 14px;
        line-height: 30px;
    }
}
.shadowClose1 {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0px;
    right: -55px;
    cursor: pointer;
}

.shadowtext1 {
    position: absolute;
    top: 50px;
    left: calc(50% - 60px);
    width: 120px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 25px;
    text-align: center;
}
</style>

<style scoped>
.shadow{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000001;
    background: rgba(0,0,0,0.4);
}
.shadowWhite{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 776px;
    height: 428px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #979797;
}
.shadowClose{
    position: absolute;
    top: 28px;
    right: 40px;
    width: 20px;
    z-index: 1;
    font-size: 32px;
    color: #000000;
    cursor: pointer;
}
.shadowText1{
    position: absolute;
    top: 32px;
    width: 100%;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
    text-align: center;
}
.shadowText2{
    position: absolute;
    top: 88px;
    left: 64px;
    width: 648px;
    height: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 32px;
}
.shadowSel{
    position: absolute;
    top: 192px;
    left: 100px;
    width: 276px;
    height: 157px;
    cursor: pointer;
    background: rgba(0,0,0,0.4);
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
    overflow: hidden;
}
.shadowSel:hover{
    border: 2px solid #1890FF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
}
.purchaseAuthLetterDialog{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 560px;
    max-width: 92vw;
    box-sizing: border-box;
    padding: 48px 40px 32px;
    background: #FFFFFF;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.12);
}
.purchaseAuthLetterClose{
    position: absolute;
    top: 20px;
    right: 24px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 1;
}
.purchaseAuthLetterTitle{
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
    margin-bottom: 16px;
}
.purchaseAuthLetterIntro{
    font-size: 14px;
    line-height: 22px;
    color: rgba(0,0,0,0.65);
    text-align: center;
    margin-bottom: 20px;
}
.purchaseAuthLetterRejectLine{
    margin-top: 8px;
    color: rgba(0,0,0,0.65);
}
.purchaseAuthLetterDrop{
    position: relative;
    border: 1px dashed #D9D9D9;
    border-radius: 8px;
    padding: 28px 16px;
    text-align: center;
    cursor: pointer;
    background: #FAFAFA;
    transition: border-color 0.2s, background 0.2s;
}
.purchaseAuthLetterDropActive{
    border-color: #409EFF;
    background: #f0f7ff;
}
.purchaseAuthLetterDropIcon{
    margin-bottom: 12px;
}
.purchaseAuthLetterDropMain{
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    margin-bottom: 8px;
}
.purchaseAuthLetterDropSub{
    font-size: 12px;
    color: rgba(0,0,0,0.45);
}
.purchaseAuthLetterFileInput{
    display: none;
}
.purchaseAuthLetterFileRow{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 12px;
    font-size: 14px;
    color: #409EFF;
}
.purchaseAuthLetterFileName{
    text-decoration: underline;
    max-width: 380px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.purchaseAuthLetterFileRemove{
    cursor: pointer;
    color: rgba(0,0,0,0.45);
    font-size: 18px;
    line-height: 1;
    text-decoration: none;
}
.purchaseAuthLetterTemplateLink{
    display: block;
    text-align: center;
    margin-top: 16px;
    font-size: 14px;
    color: #409EFF;
    text-decoration: underline;
    cursor: pointer;
}
.purchaseAuthLetterFooter{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 28px;
}
.purchaseAuthLetterBtnPrimary{
    min-width: 120px;
    padding: 0 24px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #409EFF;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
}
.purchaseAuthLetterBtnPrimary:hover{
    background: #66b1ff;
}
.purchaseAuthLetterBtnGhost{
    min-width: 120px;
    padding: 0 24px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fff;
    color: rgba(0,0,0,0.85);
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
}
.purchaseAuthLetterBtnGhost:hover{
    border-color: #409EFF;
    color: #409EFF;
}
/* 基础流量空状态 */
.basis-empty{
    position: relative;
    width: 100%;
    min-height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 0 20px;
}
.basis-empty-icon{
    width: 100px;
    height: 100px;
    margin-bottom: 16px;
}
.basis-empty-text{
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #8C8C8C;
    line-height: 22px;
    text-align: center;
}
.basis-empty-link{
    color: #1890FF;
    cursor: pointer;
}
.basis-empty-link:hover{
    text-decoration: underline;
}
/* 领取每日免费流量弹窗 */
.free-dialog {
    position: fixed;
    width: 480px;
    height: auto;
    padding: 40px 48px 36px;
    border-radius: 16px;
    left: calc(50% - 288px);
    top: calc(50% - 160px);
    z-index: 1000002;
    background: #ffffff;
    box-sizing: border-box;
}
.free-dialog-close{
    position: absolute;
    top: 16px;
    right: 16px;
    width: 20px;
    cursor: pointer;
    z-index: 1;
}
.free-dialog-title {
    width: 100%;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #1F1F1F;
    line-height: 32px;
    text-align: center;
}
.free-dialog-desc {
    width: 100%;
    height: 24px;
    margin-top: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    text-align: center;
}
.free-dialog-check {
    width: 100%;
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.free-checkbox {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    cursor: pointer;
    accent-color: #1890FF;
}
.free-check-text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
}
.free-link {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1890FF;
    line-height: 20px;
    cursor: pointer;
}
.free-dialog-buttons {
    width: 100%;
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
}
.free-btn-cancel {
    width: 160px;
    height: 44px;
    border-radius: 8px;
    border: 1px solid #D9D9D9;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
    background: #ffffff;
}
.free-btn-cancel:hover {
    border-color: #40A9FF;
    color: #40A9FF;
}
.free-btn-confirm {
    width: 160px;
    height: 44px;
    border-radius: 8px;
    background: #1890FF;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
}
.free-btn-confirm:hover {
    background: #40A9FF;
}
.free-btn-disabled {
    background: #BAE0FF;
    cursor: not-allowed;
}
.free-btn-disabled:hover {
    background: #BAE0FF;
}
/* 领取成功弹窗 */
.success-dialog {
    position: fixed;
    width: 480px;
    height: auto;
    padding: 40px 48px 36px;
    border-radius: 16px;
    left: calc(50% - 288px);
    top: calc(50% - 160px);
    z-index: 1000002;
    background: #ffffff;
    box-sizing: border-box;
}
.success-icon {
    width: 48px;
    height: 48px;
    background: #52C41A;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
}
.success-check {
    color: #ffffff;
    font-size: 28px;
    font-weight: bold;
    line-height: 1;
}
.success-title {
    width: 100%;
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    line-height: 28px;
    text-align: center;
}
.success-desc {
    width: 100%;
    margin-top: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    text-align: center;
}
.success-highlight {
    font-weight: 600;
    color: #FF6600;
}
.success-link-text {
    color: #1890FF;
}
.success-buttons {
    width: 100%;
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
}
.success-btn-cancel {
    width: 160px;
    height: 44px;
    border-radius: 8px;
    border: 1px solid #D9D9D9;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
    background: #ffffff;
}
.success-btn-cancel:hover {
    border-color: #40A9FF;
    color: #40A9FF;
}
.success-btn-confirm {
    width: 160px;
    height: 44px;
    border-radius: 8px;
    background: #1890FF;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
}
.success-btn-confirm:hover {
    background: #40A9FF;
}
.authLetterLayer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000002;
    pointer-events: auto;
}
.authLetterTopTip {
    position: absolute;
    top: 20px;
    left: 16px;
    right: 16px;
    z-index: 2;
    text-align: center;
    box-sizing: border-box;
    pointer-events: none;
}
.authLetterTopTipInner {
    display: inline-flex;
    align-items: flex-start;
    gap: 8px;
    max-width: 90%;
    padding: 10px 16px;
    border-radius: 4px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12);
    pointer-events: auto;
    text-align: left;
}
.authLetterTopTipInner--success {
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    color: rgba(0,0,0,0.88);
}
.authLetterTopTipInner--error {
    background: #fff2f0;
    border: 1px solid #ffccc7;
    color: rgba(0,0,0,0.88);
}
.authLetterTopTipText {
    line-height: 1.4;
    word-break: break-word;
}
.authLetterTopTipMark {
    flex-shrink: 0;
    font-weight: 700;
    line-height: 1.2;
}
.authLetterTopTipInner--success .authLetterTopTipMark {
    color: #52c41a;
}
.authLetterTopTipInner--error .authLetterTopTipMark {
    color: #ff4d4f;
}
.authLetterShadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0,0,0,0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    box-sizing: border-box;
}
.authLetterModal {
    position: relative;
    width: 600px;
    max-width: 100%;
    max-height: 90vh;
    overflow: auto;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.12);
    padding: 28px 32px 32px;
    box-sizing: border-box;
}
.authLetterClose {
    position: absolute;
    top: 20px;
    right: 24px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 1;
}
.authLetterTitle {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: rgba(0,0,0,0.88);
    margin-bottom: 16px;
    padding-right: 32px;
}
.authLetterDesc {
    text-align: center;
    font-size: 15px;
    line-height: 1.6;
    color: rgba(0,0,0,0.65);
    margin-bottom: 20px;
}
.authLetterReject {
    text-align: center;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0,0,0,0.45);
    margin-bottom: 20px;
}
.authLetterDrop {
    border: 1px dashed #c9cdd4;
    background: #fafafa;
    border-radius: 8px;
    padding: 32px 16px 28px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 12px;
    transition: background 0.2s, border-color 0.2s;
}
.authLetterDrop--active {
    background: #f0f7ff;
    border-color: #1E81EB;
}
.authLetterFileInput {
    display: none;
}
.authLetterDropIcon {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
}
.authLetterDropLine1 {
    font-size: 15px;
    color: rgba(0,0,0,0.88);
    margin-bottom: 8px;
}
.authLetterDropLine2 {
    font-size: 12px;
    color: rgba(0,0,0,0.45);
}
.authLetterFileRow {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    margin-bottom: 4px;
    padding: 0 4px;
}
.authLetterFileClip {
    margin-right: 6px;
    font-size: 14px;
}
.authLetterFileName {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.authLetterFileRemove {
    margin-left: 8px;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    color: #999;
}
.authLetterFileRemove:hover {
    color: #333;
}
.authLetterBar {
    height: 2px;
    background: #1E81EB;
    border-radius: 1px;
    margin: 0 0 12px 0;
}
.authLetterLink {
    display: block;
    text-align: center;
    color: #1E81EB;
    font-size: 15px;
    margin-bottom: 24px;
    cursor: pointer;
    text-decoration: none;
}
.authLetterLink:hover {
    text-decoration: underline;
}
.authLetterLink--disabled {
    color: #bfbfbf !important;
    cursor: not-allowed;
    pointer-events: none;
}
.authLetterBtns {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 16px;
}
.authLetterBtn1 {
    min-width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #1E81EB;
    color: #fff;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 24px;
    border: none;
}
.authLetterBtn1--disabled {
    opacity: 0.55;
    cursor: not-allowed;
}
.authLetterBtn2 {
    min-width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fff;
    color: rgba(0,0,0,0.45);
    font-size: 16px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 24px;
}
/* 流量使用设置弹窗 */
.flowSettingDialog{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 680px;
    height: calc(720px - 63px);
    max-height: 90vh;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 32px 32px 32px 32px;
    background: #FFFFFF;
    border-radius: 16px;
    z-index: 1000002;
}
.flowSettingClose{
    position: absolute;
    top: 26px;
    right: 26px;
    width: 12px;
    height: 12px;
    cursor: pointer;
    z-index: 2;
}
.flowSettingClose::before,
.flowSettingClose::after{
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 16px;
    height: 2px;
    background: #8C8C8C;
    border: 0;
}
.flowSettingClose::before{
    transform: translate(-50%, -50%) rotate(45deg);
}
.flowSettingClose::after{
    transform: translate(-50%, -50%) rotate(-45deg);
}
.flowSettingTitle{
    font-family: PingFangSC-Semibold, PingFang SC;
    font-size: 18px;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
}
.flowSettingBottomDivider{
    position: absolute;
    bottom: 91px;
    left: 0;
    width: 680px;
    height: 1px;
    background: #F0F0F0;
    border: none;
}
.flowSettingDivider{
    position: absolute;
    top: 64px;
    left: 0;
    width: 680px;
    height: 1px;
    background: #F0F0F0;
    border: none;
}
/* 模式卡片 */
.flowModeCard{
    position: relative;
    width: 616px;
    height: 88px;
    box-sizing: border-box;
    margin-top: 20px;
    padding: 0;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;
}
.flowModeCard--active{
    border: 2px solid #1890FF;
    background: #E6F7FF;
}
.flowModeRadio{
    margin-left: 16px;
    margin-right: 16px;
    width: 16px;
    height: 16px;
    border: 2px solid #D9D9D9;
    border-radius: 50%;
    box-sizing: border-box;
    background: #FFFFFF;
    flex-shrink: 0;
    line-height: 1;
}
.flowModeRadio--on{
    border: 2px solid #1890FF;
    background: #FFFFFF;
    position: relative;
}
.flowModeRadio--on::after{
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #1890FF;
    transform: translate(-50%, -50%);
}
.flowModeContent{
    flex: 1;
    min-width: 0;
}
.flowModeHeader{
    display: flex;
    align-items: center;
}
.flowModeName{
    font-family: PingFangSC-Semibold, PingFang SC;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 22px;
}
.flowModeDefault{
    margin-left: 28px;
    width: 42px;
    height: 24px;
    box-sizing: border-box;
    line-height: 24px;
    text-align: center;
    border: 1px solid #91D5FF;
    border-radius: 2px;
    background: #E6F7FF;
    color: #1890FF;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
}
.flowModeDesc{
    margin-top: 9px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 20px;
}
/* 优先级信息卡 */
.flowPriorityCard{
    position: relative;
    width: 616px;
    height: 250px;
    box-sizing: border-box;
    margin-top: 20px;
    padding: 16px 20px 0 24px;
    background: #E6F7FF;
    border-radius: 4px;
}
.flowPriorityIcon{
    position: absolute;
    top: 18px;
    left: 16px;
    width: 16px;
    height: 16px;
}
.flowPriorityTitle{
    margin-top: 0;
    padding-left: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    line-height: 22px;
}
.flowPriorityRow{
    display: flex;
    align-items: center;
    margin-top: 14px;
}
.flowPriorityType{
    width: 166px;
    flex-shrink: 0;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-size: 13px;
    color: rgba(0,0,0,0.85);
    line-height: 20px;
}
.flowPriorityArrow{
    flex: 1;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: rgba(0,0,0,0.65);
    line-height: 20px;
}
.flowPriorityDivider{
    margin-top: 18px;
    width: 568px;
    height: 1px;
    background: #BAE7FF;
    border: none;
}
.flowPriorityTip{
    margin-top: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #1890FF;
    line-height: 20px;
}
/* 底部按钮 */
.flowSettingBtns{
    position: absolute;
    bottom: 28px;
    right: 32px;
    display: flex;
    align-items: center;
    gap: 12px;
}
.flowSettingCancel{
    width: 80px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    background: #FFFFFF;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    cursor: pointer;
    box-sizing: border-box;
}
.flowSettingSave{
    width: 104px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #1890FF;
    border-radius: 4px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
    box-sizing: border-box;
}
</style>
